export default __webpack_public_path__ + "static/Logo-1739dc3f71364c5f210b22365f1a59c8.webp";